import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VibrantFinishesForNorthQueenslandLiving() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  return <section id="vibrant-finishes-for-north-queensland-living" className="relative min-h-screen w-full overflow-hidden bg-slate-900 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/modernist_villa_castle_hill_townsville.png)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/modernist_villa_castle_hill_townsville.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(15,23,42,0.8),transparent)]" />
      </div>

      {}
      <div className="relative z-10 flex min-h-screen items-center px-6 md:px-12 lg:px-20">
        <div className="grid w-full max-w-7xl grid-cols-1 lg:grid-cols-2">
          {}
          <div ref={textRef} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="space-y-4">
              <h1 className="font-sans text-6xl font-bold leading-tight tracking-tight text-white md:text-7xl lg:text-8xl xl:text-9xl">
                Vibrant Finishes for North Queensland Living
              </h1>
              <p className="text-xl font-medium text-slate-300 md:text-2xl">
                Protection & Prestige
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-semibold shadow-lg transition-transform hover:scale-105">
                <Link to="/GetAQuotePage">Get a Free Quote</Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 border-2 border-white bg-transparent px-8 text-lg font-semibold text-white shadow-lg transition-all hover:scale-105 hover:bg-white hover:text-slate-900 hover:border-white">
                <Link to="/WorkGalleryPage">View Our Work</Link>
              </Button>
            </div>
          </div>

          {}
          
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-pulse">
        <div className="flex flex-col items-center gap-2 text-white/80">
          <span className="text-xs font-medium uppercase tracking-widest">
            Scroll
          </span>
          <ChevronDown className="h-6 w-6" />
        </div>
      </div>
    </section>;
}